import { useContext, useEffect, useState } from "react";
import { GAME_STAGES, DEFAULT_ROOM, HOME_PATH } from "../../constants/gameStages";
import { useNavigate } from "react-router-dom";
import WaitingButton from "../../components/WaitingButton";
import { SocketContext } from "../../context/SocketProvider";
import { PausedOverlay } from "../../components";
import { useGameStage } from "../../hooks/useGameStage";
import { useGameDataSync } from "../../hooks/useGameDataSync";
import { useRoleBackground } from "../../hooks/useRoleBackground";
import { useLanguage } from "../../context/LanguageContext";
import hint1 from "../../assets/hint1.png";
import hint1_jp from "../../assets/hint1_jp.png";

function WaitingForDescriber({ gameStage }) {
  const { socket } = useContext(SocketContext);
  const [canProceed, setCanProceed] = useState(false);
  const { gameData } = useGameDataSync();
  const { showPausedOverlay, setShowPausedOverlay } = useContext(SocketContext);
  const navigate = useNavigate();
  const { updateStage } = useGameStage();
  const { bgStyle, className } = useRoleBackground("blue");
  const { t, language } = useLanguage();

  // Select appropriate hint image based on language
  const hintImage = language === 'ja' ? hint1_jp : hint1;

  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev === 3 ? 1 : prev + 1));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const dotString = ".".repeat(dotCount);

  const destination =
    gameStage === GAME_STAGES.WAITING_FOR_GUESSER
      ? "/guesserguess"
      : "/waitingfordescriber";

  useEffect(() => {
    // If game has moved to RESULTS stage, navigate to AI waiting screen
    if (gameStage === GAME_STAGES.RESULTS) {
      navigate("/aiwaiting", { replace: true });
      return;
    }

    if (
      // gameData?.description &&
      gameStage === GAME_STAGES.WAITING_FOR_GUESSER
    ) {
      setCanProceed(true);
    } else {
      const timeout = setTimeout(() => {
        console.log("🔁 Re-requesting game data...");
        socket.emit("get_game_data", { room: DEFAULT_ROOM });
      }, 50); // delay in milliseconds

      return () => clearTimeout(timeout);
    }
  }, [gameData, gameStage, navigate]);

  return (
    <div className={className} style={bgStyle}>
      <div className="min-h-screen flex flex-col text-center items-center">
        <h1 className="text-[40px] font-bold text-black mt-[128px] mb-[32px]">
          {canProceed 
            ? t('guesser.waitingDone', "The Describer has finished writing!")
            : (
              <>
                {t('guesser.waiting', "The Describer is writing a description")}
                <span className="inline-block w-12 text-left">{dotString}</span>
              </>
            )
          }
        </h1>
        <div className="mb-[64px]">
          {canProceed ? (
            <WaitingButton
              proceed={true}
              destination={destination}
              nextMsg={t('button.continue', 'Continue!')}
              nextClassName="btn-blue-lg"
              className="btn-blue-lg"
            />
          ) : (
            <button className="btn-blue-lg" disabled={true}>
              {t('button.continue', 'Continue!')}
            </button>
          )}
        </div>
        <img src={hintImage} alt={t('alt.hints', 'hints')} className="absolute bottom-0" />

        {/* <ConfirmReturnButton modal={false} /> */}
        {showPausedOverlay && (
          <PausedOverlay
            onReload={() => {
              updateStage(GAME_STAGES.WAITING);
              setShowPausedOverlay(false);
              navigate(HOME_PATH);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default WaitingForDescriber;
